<!-- 创建时间2023/06/26 15:06:20 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：批量修改抽屉 -->
<!-- 创景描述：批量创建课件时使用，包含直接上传、发表微课、从知识库选择 -->
<template>
  <yxt-drawer :title="$t('pc_kng_upload_lbl_batch_change'/**批量修改 */)" :visible.sync="visible" size="960px" destroy-on-close>
    <kng-form ref="form" :info="info" batchSetting/>
    <div slot='footer'>
      <yxt-button plain @click="visible = false">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
      <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import { COURSE_ATTRIBUTE } from '../../enum';
import { getSystemCoverImages, getTreeNodePathByKey, getDefaultKngTypeCover } from '../../utils';
import KngForm from './widget/kng-form.vue';
export default {
  name: 'kng-edit-multi-drawer',
  inject: ['getCatalogData', 'getAttrConfigs', 'getModule', 'getConfig', 'getMultiConfig'],
  components: {
    KngForm
  },
  data() {
    return {
      info: {},
      visible: false,
      infoList: [] // 带批量修改的课件
    };
  },
  computed: {
    config() {
      return this.getConfig();
    },
    multiConfig() {
      return this.getMultiConfig();
    },
    catalogData() {
      return this.getCatalogData();
    },
    attrConfigs() {
      return this.getAttrConfigs();
    },
    module() {
      return this.getModule();
    }
  },
  methods: {
    init(list = [], formList = []) {
      this.infoList = list;
      this.formList = formList;
      const info = {
        visiable: this.module === 'ulcd' ? 0 : 1,
        price: undefined,
        photoType: 1,
        coverUrl: getSystemCoverImages(),
        displayMode: 0,
        expireDay: 0,
        expireHours: 0,
        fontSize: 0,
        contributorsUser: localStorage.userId || '',
        contributorsName: localStorage.fullname || '',
        shareEnabled: 1,
        permissionType: 0,
        visitorConfDTO: {},
        enableStudyedAlert: 1,
        watermarkFlag: 0,
        faceRecognitionConfig: {},
        subtitlesFlag: 0,
        syncMark: 0
      };
      info.enableDrag = 1 - this.config.forbidDrag;
      const {enabled, multipleMode, multipleStudy} = this.multiConfig;
      if (enabled === 1) {
        info.enableMultipleSwitch = 1;
        info.enableMultiple = multipleMode === 1 ? multipleStudy : 1;
      }
      this.initCustomAttributesOfInfo(info);
      if (this.catalogData.tree.length && this.catalogData.tree[0].children && this.catalogData.tree[0].children.length) {
        const { catalogId } = this.$route.query;
        let obj = this.catalogData.tree[0].children[0];
        if (catalogId) {
          const ret = getTreeNodePathByKey(catalogId, this.catalogData.tree).node;
          if (ret) {
            if (ret.id === ret.collegeId && ret.children && ret.children.length) {
              obj = ret.children[0];
            } else if (ret.id !== ret.collegeId) {
              obj = ret;
            }
          }
        }
        info.catalogId = obj.id;
        info.catalogName = obj.label;
      }
      this.info = info;
      this.visible = true;
    },
    initCustomAttributesOfInfo(info) {
      info.customAttributes = [];
      this.attrConfigs.forEach(item => {
        if (
          item.attrKey === COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE ||
          item.attrKey === COURSE_ATTRIBUTE.CUSTOM_RELATED
        ) {
          let data = info.customAttributes.find(it => it.attrId === item.id);
          if (!data) {
            data = {
              attrKey: item.attrKey,
              attrName: item.attrName,
              attrId: item.id,
              userName: '',
              value: ''
            };
            info.customAttributes.push(data);
          }
        }
      });
    },
    confirm() {
      // 延迟一点时间，让富文本失去焦点事件发生，修改数据
      setTimeout(() => {
        this.$refs.form.validate()
          .then(() => {
            for (let i = 0; i < this.infoList.length; i++) {
              this.setInfoData(this.infoList[i], this.formList[i]);
            }
            this.visible = false;
            this.$message.success(this.$t('pc_edit_success'));
            this.$emit('confirm');
          });
      }, 100);
    },
    setInfoData(info, form) {
      // 分类
      if (form.getItemShow(COURSE_ATTRIBUTE.CATAlOG)) {
        this.$set(info, 'catalogId', this.info.catalogId);
        this.$set(info, 'catalogName', this.info.catalogName);
      }
      // 封面
      this.$set(info, 'photoType', this.info.photoType);
      if (this.info.photoType === 3) {
        // 课件类型
        this.$set(info, 'coverUrl', getDefaultKngTypeCover(info.fileType));
      } else if (this.info.photoType !== 4) {
        // 非智能封面
        this.$set(info, 'coverUrl', this.info.coverUrl);
      }
      // 价格
      if (form.getItemShow(COURSE_ATTRIBUTE.PRICE) && !form.getItemDisabled(COURSE_ATTRIBUTE.PRICE)) {
        this.$set(info, 'price', this.info.price);
      }
      // 内容标签
      if (form.getItemShow(COURSE_ATTRIBUTE.CONTENT_TAG)) {
        this.$set(info, 'contentTags', this.info.contentTags);
      }
      // 供应商
      if (form.getItemShow('supplier')) {
        this.$set(info, 'supplierId', this.info.supplierId);
        this.$set(info, 'supplierName', this.info.supplierName);
      }
      // 资料类型
      if (form.getItemShow('dataType')) {
        this.$set(info, 'studyMaterialType', this.info.studyMaterialType);
      }
      // 能力标签
      if (form.getItemShow(COURSE_ATTRIBUTE.SKILL_TAG)) {
        this.$set(info, 'skillTags', this.info.skillTags);
      }
      // 有效期
      if (form.getItemShow(COURSE_ATTRIBUTE.VALID_DATE) && !form.getItemDisabled(COURSE_ATTRIBUTE.VALID_DATE)) {
        this.$set(info, 'expiredTime', this.info.expiredTime);
        this.$set(info, 'expireNotice', this.info.expireNotice);
        this.$set(info, 'expireDay', this.info.expireDay);
        this.$set(info, 'expireHours', this.info.expireHours);
      }
      // 展示模式
      if (form.getItemShow('displayMode') && !form.getItemDisabled('displayMode')) {
        this.$set(info, 'displayMode', this.info.displayMode);
      }
      // 字号
      if (form.getItemShow('displayMode') && form.getItemShow('fontSize')) {
        this.$set(info, 'fontSize', this.info.fontSize);
      }
      // 简介
      if (form.getItemShow(COURSE_ATTRIBUTE.DESCRIBE)) {
        this.$set(info, 'description', this.info.description || '');
      }
      // 附件
      if (form.getItemShow(COURSE_ATTRIBUTE.ATTACHMENT) && !form.getItemDisabled(COURSE_ATTRIBUTE.ATTACHMENT)) {
        this.$set(info, 'kngAttachSimpleBeans', this.info.kngAttachSimpleBeans);
      }
      // 自定义属性
      this.$set(info, 'customAttributes', this.info.customAttributes);
      // 贡献者
      if (form.getItemShow(COURSE_ATTRIBUTE.CONTRIBUTOR)) {
        this.$set(info, 'contributorsName', this.info.contributorsName);
        this.$set(info, 'contributorsUser', this.info.contributorsUser);
        this.$set(info, 'rewardFlag', this.info.rewardFlag);
      }
      // 作者
      if (form.getItemShow(COURSE_ATTRIBUTE.AUTHOR)) {
        this.$set(info, 'author', this.info.author);
        this.$set(info, 'authorId', this.info.authorId);
        this.$set(info, 'originality', this.info.originality);
      }
      // 主讲老师
      if (form.getItemShow(COURSE_ATTRIBUTE.LECTURER)) {
        this.$set(info, 'lecturesName', this.info.lecturesName);
        this.$set(info, 'lecturesId', this.info.lecturesId);
      }
      // 辅讲老师
      if (form.getItemShow(COURSE_ATTRIBUTE.ASSISTANT_LECTURER)) {
        this.$set(info, 'counseLorteacherNames', this.info.counseLorteacherNames);
        this.$set(info, 'counseLorteacherIds', this.info.counseLorteacherIds);
      }
      // 隐藏
      this.$set(info, 'visiable', this.info.visiable);
      // 分享权限
      this.$set(info, 'shareEnabled', this.info.shareEnabled);
      // 浏览
      this.$set(info, 'permissionType', this.info.permissionType);
      this.$set(info, 'browsePermissions', this.info.browsePermissions);
      // 下载权限
      if (form.getItemShow('download') && !form.getItemDisabled('download')) {
        this.$set(info, 'downEnabled', this.info.downEnabled);
        this.$set(info, 'allowDown', this.info.allowDown);
        this.$set(info, 'downloadPermissions', this.info.downloadPermissions);
      }
      if (form.getItemShow('download_source') && !form.getItemDisabled('download_source')) {
        this.$set(info, 'downloadType', this.info.downloadType);
      }
      // app缓存
      if (form.getItemShow('appCache') && !form.getItemDisabled('appCache')) {
        this.$set(info, 'appDownEnabled', this.info.appDownEnabled);
        this.$set(info, 'allowAppDown', this.info.allowAppDown);
        this.$set(info, 'appDownloadPermissions', this.info.appDownloadPermissions);
      }
      // 游客
      if (form.getItemShow('visitor')) {
        this.$set(info, 'visitorConfDTO', this.info.visitorConfDTO);
      }
      // 完课评论
      this.$set(info, 'enableStudyedAlert', this.info.enableStudyedAlert);
      // 讨论区
      if (form.getItemShow('bbs')) {
        this.$set(info, 'enableBbs', this.info.enableBbs);
      }
      // 笔记区
      if (form.getItemShow('note')) {
        this.$set(info, 'enableNote', this.info.enableNote);
      }
      // 水印
      if (form.getItemShow('watermark')) {
        this.$set(info, 'watermarkFlag', this.info.watermarkFlag);
      }
      // 倍速播放、学时计算
      if (form.getItemShow('multiShow') && !form.getItemDisabled('multiShow')) {
        this.$set(info, 'enableMultipleSwitch', this.info.enableMultipleSwitch);
        this.$set(info, 'enableMultiple', this.info.enableMultiple);
      }
      // 拖拽学习
      if (form.getItemShow('drag') && !form.getItemDisabled('drag')) {
        this.$set(info, 'enableDrag', this.info.enableDrag);
      }
      // 人脸
      if (form.getItemShow('face')) {
        this.$set(info, 'faceRecognitionConfig', this.info.faceRecognitionConfig);
      }
      // AI字幕设置
      if (form.getItemShow('AI') && !form.getItemDisabled('AI')) {
        this.$set(info, 'subtitlesFlag', this.info.subtitlesFlag);
        this.$set(info, 'syncMark', this.info.syncMark);
      }
    }
  }
};
</script>